import { render, staticRenderFns } from "./AddFixedDeparture.vue?vue&type=template&id=57fdd910"
import script from "./AddFixedDeparture.vue?vue&type=script&lang=js"
export * from "./AddFixedDeparture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports